import { HttpErrorResponse } from '@angular/common/http';

export class ErrorDetailModalData {
    constructor(public action: string = '',
                public text: string = '',
                public detailText: string = '',
                public httpError: HttpErrorResponse = null) {
    }
}
